import { css } from '@emotion/react'
import React from 'react'

import Single from '../components/contents/Single'
import { mq, rem } from '../styles/mixin.styles'
import { colors, fontSize, space } from '../styles/variables.styles'

type Props = {
  location: {
    [key: string]: string
  }
}

const TermsPage = ({ location }: Props) => {
  return (
    <Single
      slug="terms"
      readText={
        <>
          この利用規約はパレット調達支援システム「iPaS」の利用条件を定めるものです。
          <br />
          登録ユーザーのみなさまには本規約に従って、本サービスをご利用いただきます。
        </>
      }
      pathname={location.pathname}
    >
      <div css={termsStyles}>
        <h2>総則</h2>
        <h3>（目的）</h3>
        <p>
          パレット調達支援システム iPaS
          利用規約（以下「本規約」といいます。）は、五十鈴関東株式会社（以下「当社」といいます。）が提供する本サービス（第３条第１号に定義します。）の利用にあたり遵守すべき基本的事項を定めるものです。
        </p>
        <h3>（適用）</h3>
        <ol>
          <li>
            本規約は、当社と本サービスの利用者（以下、単に「利用者」といいます。）との間の本サービスの利用に関する契約（以下「利用契約」といいます。）の内容を定めるものであり、当社と利用者との間の本サービスに関する関係に適用されます。
          </li>
          <li>
            本サービスに関して当社が別途定めるガイドラインその他の規約（以下「ガイドライン等」といいます。）は、その名称の如何を問わず本規約の一部を構成し、本規約と重畳的に適用されます。
          </li>
          <li>
            本規約と、当社と利用者が締結した個別の利用契約（第6条第3項に定義する申込書の特記事項欄の記載を含みます。）との間で矛盾抵触が生じた場合、個別の利用契約の定めが優先するものとします。
          </li>
        </ol>
        <h3>（定義）</h3>
        <p>本規約における用語の定義は、次の各号に定めるとおりとします。</p>
        <ol className="ol--brackets">
          <li>
            本サービス
            <br />
            当社が「iPaS」の名称で提供するサービス（具体的な内容については第4条にて定義します。）
          </li>
          <li>
            オプションサービス
            <br />
            当社が本サービスに付随関連して追加の利用料金を設定することを前提として提供するサービス
          </li>
          <li>
            本システム
            <br />
            当社が本サービスに付随関連して提供するパレット調達支援システムその他のシステム（修正版、アップデート版も含みます。）
          </li>
          <li>
            コンテンツ
            本サービスの提供のため、文字、テキスト、図形、音、画像、映像又はソフトウェア等により本システム上に表現された情報
          </li>
          <li>
            外部事業者パレット構想図
            <br />
            パレットメーカーに対してパレットの設計業務を委託する前提として利用者が作成する簡易な構想図面のうち、利用者が外部事業者（図面等を作成することを目的として開発されたソフトウェアを提供するサービスプロバイダ）のサービスを使用して作成した構造図面
          </li>
          <li>
            当社パレット構想図
            <br />
            パレットメーカーに対してパレットの設計業務を委託する前提として利用者が作成する簡易な構想図面のうち、利用者が本サービスを使用して作成した構造図面
          </li>
          <li>
            パレットメーカー製作図
            <br />
            外部事業者のサービスを使用してパレットメーカーが作成した設計図面
          </li>
          <li>
            当社パレット製作図
            <br />
            パレットメーカー製作図を前提として当社がXVL形式に変換する方法により作成し、本システム上にアップロードした製作図
          </li>
        </ol>
        <h2>本サービスの内容等</h2>
        <h3>（本サービスの内容）</h3>
        <ol>
          <li>
            本サービスは、利用者がパレットを調達するにあたって必要となる荷姿構想図の作成、荷姿検討会の実施、パレット発注先の選定その他の業務のサポートを行うサービスです。
          </li>
          <li>
            本サービスの内容は、次の各号に定めるとおりとします。
            <ol className="ol--brackets">
              <li>本システム上での当社パレット構想図の作成サポート</li>
              <li>本システム上での荷姿検討会の実施サポート</li>
              <li>
                本システム上でのパレット発注先のパレットメーカーの選定サポート（一斉引合及び見積取得のサポートを含みます。）
              </li>
              <li>
                本システム上での過去事例（当社パレット製作図を含みます。）の検索サポート（本システム上での参考事例の提案を含みます。）
              </li>
              <li>本システム上での過去事例の閲覧、複製サポート</li>
              <li>その他当社が別途定めるサービス</li>
            </ol>
          </li>
        </ol>
        <h3>（オプションサービス等）</h3>
        <ol>
          <li>
            当社は、利用者を対象として、オプションサービスを有料で提供する場合があります。オプションサービスの利用を希望する利用者は、当社が別途定める方法によりオプションサービスの利用を申し込み、当社との間でオプションサービスの利用契約を別途締結する必要があります。なお、当社が別段の定めをしない限り、オプションサービスについても本規約が適用されるものとします。
          </li>
          <li>
            利用者は、本サービスと連携させて、当社が指定する外部事業者のサービスを利用（外部事業者パレット構想図の使用を含みます。）できる場合があります。当該外部事業者のサービスの利用を希望する利用者は、当該外部事業者のサービス利用規約に同意した上で、各サービスの提供条件等に従い、利用者自身の責任と費用負担で外部事業者のサービスを利用するものとします。また、当社は、当該外部事業者のサービスの内容、品質、不適合、変更、終了その他の外部事業者のサービスに起因する損害について、一切責任を負いません。
          </li>
        </ol>
        <h3>（本サービスの利用条件）</h3>
        <ol>
          <li>当社は、本規約に定める条件に従い、本サービスを提供します。</li>
          <li>
            本サービスの利用条件その他の細目については、ガイドライン等に定めるものとします。利用者は、本規約の他、ガイドライン等に従い、本サービスを利用するものとします。
          </li>
          <li>
            前項の規定にかかわらず、本サービスの利用条件のうち次の条件については、申込書（第10条第1項に定義します。）で定めるものとします。
            <ol className="ol--brackets">
              <li>１契約で利用できる個人用アカウント（第8条に定義します。）の数</li>
              <li>利用料金等（第13条に定義します。）</li>
              <li>利用契約の有効期間</li>
              <li>利用契約締結時点におけるユーザー（第8条に定義します。） </li>
              <li>利用契約締結時点における連絡責任者</li>
              <li>特約事項</li>
            </ol>
          </li>
        </ol>
        <h3>（本システムの利用許諾）</h3>
        <ol>
          <li>当社は、利用契約の有効期間中、利用者が本規約に従って本システムを利用することを許諾します。</li>
          <li>前項により利用者に許諾される権利は、譲渡及び再許諾不可の非独占的なものとします。</li>
        </ol>
        <h3>（アカウントの登録、変更、停止又は削除）</h3>
        <ol>
          <li>
            当社は、本サービス及び本システムの利用を許諾する利用者１社につき、１つの企業用アカウント（以下「企業用アカウント」といいます。）を登録します。
          </li>
          <li>
            当社は、本サービス及び本システムの利用を許諾する利用者の従業者（以下「ユーザー」といいます。）１人につき、１つの個人用アカウント（以下「個人用アカウント」といい、企業用アカウントと併せて「アカウント」といいます。）を登録します。
          </li>
          <li>
            個人用アカウントの登録対象となるユーザーは、当社が別途指定する方法により、利用者が指定するものとします。
          </li>
          <li>
            個人用アカウントの追加、変更又は削除を希望する場合、利用者は、当社所定の「アカウント申請登録書」を当社指定の方法で当社に提出します。
          </li>
          <li>
            当社は、ユーザーが次の各号のいずれかに該当すると当社が判断した場合には、当該ユーザーの個人用アカウントを停止し、又は削除することができるものとします。
            <ol className="ol--brackets">
              <li>ユーザーが本規約に違反する態様で本サービスを利用するおそれがあると当社が判断した場合</li>
              <li>ユーザーが反社会的勢力等（第36条に定義します。）と認められる場合</li>
            </ol>
          </li>
        </ol>
        <h3>（知的財産権）</h3>
        <ol>
          <li>
            利用者が本サービスを利用して作成したコンテンツ（当社パレット構想図を含みます。）の著作権（著作権法第27条及び第28条が規定する権利を含み、以下同様とします。）その他の知的財産権は、利用者に帰属します。
          </li>
          <li>
            利用者が外部事業者のサービスを利用して作成したコンテンツ（外部事業者パレット構想図を含みます。）の著作権その他の知的財産権は、利用者又は当該権利を留保する外部事業者その他の第三者に帰属します。
          </li>
          <li>
            パレットメーカーが外部事業者のサービスを利用して作成したコンテンツ（パレットメーカー製作図を含みます。）の著作権その他の知的財産権はパレットメーカー又は当該権利を留保する外部事業者その他の第三者に帰属します。
          </li>
          <li>
            前三項に定めるものを除き、本サービス、本システム、本サービスに関連するソフトウェア、本サービスに関連して当社が加工、編集したコンテンツ及び統計情報、並びに本サービスにより作成されたデータ（当社パレット製作図を含みます。）に関する著作権その他一切の知的財産権は、当社に帰属します。
          </li>
          <li>
            利用者は、当社に対し、本サービスの提供、当社のマーケティング調査、当社サービスの研究開発調査、その他当社プライバシーポリシーに定める利用目的のために、当社が地域、国及び期限の制限なく、法令、本規約及び当社プライバシーポリシーに反しない範囲において、利用者に知的財産権が帰属するコンテンツを利用、複製、翻案、頒布し、又は二次的著作物を作成、表示若しくは実行できる権利、及びこれらの権利を再許諾する権利を無償で許諾するものとします。利用者は、当社及び当社から権利を承継し又は許諾された第三者に対し、当該コンテンツについて著作者人格権を行使しないものとします。
          </li>
        </ol>
        <h2>利用契約の成立・有効期間</h2>
        <h3>（利用契約の締結）</h3>
        <ol>
          <li>
            本サービスの利用を希望する者は、本規約に同意の上、当社所定の申込書（以下「申込書」といいます。）を当社に提出し、本サービスの利用契約の申込みを行うものとします。なお、申込書の内容は利用契約の内容となります。
          </li>
          <li>
            前項の申込みを行った者（以下「申込者」といいます。）は、当社に対し、当該利用契約の申込みを行っている者が当社と利用契約を締結する権限を有するであることを保証します。
          </li>
          <li>
            利用契約は、第1項の申込みを当社が承諾した時点で成立します。なお、利用契約の成立日にかかわらず、本サービスの利用開始可能日は、第12条に定める利用契約の有効期間の初日とし、当該サービス利用開始可能日の属する月より利用料金等（第13条に定義します。）が発生します。また、申込者は、利用契約の成立日より利用者として取り扱われます。
          </li>
        </ol>
        <h3>（申込みの拒絶）</h3>
        <ol>
          <li>
            当社は、次の各号のいずれかに該当する場合には、本サービスの利用申込みを承諾しないことがあります。
            <ol className="ol--brackets">
              <li>本サービスの提供が困難であると当社が判断した場合</li>
              <li>
                申込者が当社との契約に違反するおそれがあると当社が判断した場合、又は申込者が過去に当社との契約に違反したことがある場合
              </li>
              <li>申込書の内容に不実、虚偽若しくは過誤又は記載漏れがあった場合</li>
              <li>申込者が反社会的勢力等（第36条に定義します。）と認められる場合</li>
              <li>申込者が第19条に定める禁止事項に該当するおそれがあると当社が判断した場合</li>
              <li>その他申込みを承諾することが相当でないと当社が判断した場合</li>
            </ol>
          </li>
          <li>
            前項の規定により本サービスの申込みを拒絶した場合、当社は、申込者に対し、申込みを拒絶する旨を速やかに通知します。但し、当社は、申込者に対し、申込みを拒絶する理由を開示する義務を負わないものとします。
          </li>
        </ol>
        <h3>（有効期間）</h3>
        <ol>
          <li>利用契約の有効期間は、申込書で定めた期間とします。</li>
          <li>
            前項の規定にかかわらず、前項の有効期間満了の1か月前までに、当社所定の方法により、利用者又は当社から更新しない旨の意思表示がない場合、利用契約の有効期間は、当初の利用契約の契約期間と同期間延長されるものとし、その後も同様とします。
          </li>
        </ol>
        <h2>利用料金等の支払い</h2>
        <h3>（利用料金等の支払い）</h3>
        <ol>
          <li>
            本サービスの利用料金及びオプションサービス利用料金（以下、併せて「利用料金等」といいます。）は、申込書で定めた金額とします。
          </li>
          <li>
            利用者は、利用契約の有効期間の満了前に利用契約が終了した場合（終了原因の如何を問いません。）その他いかなる場合であっても、当社に対し有効期間満了までの利用料金等全額の支払義務を負うものとし、当社は受領した利用料金等の返金を行いません。
          </li>
          <li>
            当社は、本サービスの内容の変更等（第28条に定義します。）その他の事由により利用料金等を変更する必要が生じたと判断した場合には、第39条に定める手続により、利用料金等を変更することができるものとします。
          </li>
        </ol>
        <h3>（利用料金等の支払手続）</h3>
        <ol>
          <li>
            当社は、利用者に対し、毎月末日締め翌月10日までに、利用料金等を記載した請求書（以下「請求書」といいます。）を当社が別途定める方法により発行するものとします。
          </li>
          <li>
            利用者は、当社に対し、請求書に基づき、請求書指定の支払期限までに当社が別途指定する銀行口座に振込送金する方法により利用料金等を支払うものとします。なお、振込手数料は利用者負担とします。
          </li>
        </ol>
        <h3>（遅延損害金）</h3>
        <p>
          利用者は、利用料金等の支払を遅延した場合、支払期限の翌日から完済に至るまで、年14.6％の遅延損害金を当社に支払うものとします。
        </p>
        <h2>利用者の義務及び禁止行為</h2>
        <h3>（環境設定）</h3>
        <p>
          利用者が本サービスを利用するために必要な機器、ソフトウェア、通信回線等の環境設定（セキュリティ対策の実施を含みます。）は、全て利用者の責任と費用負担で行うものとします。利用者が本サービスの利用開始に必要な環境を設定できないことにより利用者に不利益が生じた場合であっても、当社に故意又は過失がある場合を除き、当社は一切責任を負いません。
        </p>
        <h3>（アカウント等の管理）</h3>
        <ol>
          <li>
            利用者は、アカウントその他の当社から付与された認証情報（パスワードを含み、以下、総称して「アカウント等」といいます。）を、第三者に対し、譲渡、貸与その他の処分（有償無償及び処分の態様を問いません。）をすることはできないものとします。
          </li>
          <li>
            利用者は、自己の責任においてアカウント等を管理するものとします。利用者がアカウント等の管理を懈怠したことにより利用者に不利益が生じた場合であっても、当社は一切責任を負いません。
          </li>
          <li>
            利用者は、アカウント等を失念した場合又は盗用された場合は、速やかに当社に連絡し、その指示に従うものとします。
          </li>
        </ol>
        <h3>（届出事項の変更）</h3>
        <ol>
          <li>
            利用者は、当社への届出事項（申込書の記載事項を含みます。）に変更が生じた場合には、速やかにその旨を当社所定の方法により当社に届け出るものとします。
          </li>
          <li>
            利用者が前項の届出を懈怠又は遅滞したことにより利用者に不利益が生じた場合であっても、当社は一切責任を負いません。
          </li>
        </ol>
        <h3>（禁止行為）</h3>
        <p>
          利用者は、本サービスを利用するにあたり、次の各号に定める行為又は次の各号に該当するおそれがある行為を行わないものとします。
        </p>
        <ol className="ol--brackets">
          <li>
            法律、政令、省令又は府令、通達、規則、命令、条例、ガイドラインその他の規制（以下、総称して「法令等」といいます。）又は本規約に違反する行為
          </li>
          <li>
            次の①から④までに定める内容を含むコンテンツを本システム上に掲載し、第三者に開示、提供若しくは送付し、又は電子メール等の方法で送信若しくは発信する行為
            <ol className="ol--round-decimal">
              <li>法令等に違反する内容</li>
              <li>
                当社若しくは第三者の権利（財産権、著作権その他の知的財産権、プライバシー権及び名誉権を含みます。）を侵害し、又は当社若しくは第三者に損害（精神的損害を含みます。）を与える内容
              </li>
              <li>本規約に定められた目的と関連のない内容 その他当社が不適当であると判断する内容</li>
              <li>その他当社が不適当であると判断する内容</li>
            </ol>
          </li>
          <li>
            本サービスに関するシステム（本システムを含みます。）、当社のサーバー、本サービスに接続しているサーバーその他の設備に過大な負荷を与えるような行為
          </li>
          <li>
            他の利用者のアカウント等を不正に使用する行為、又は他の利用者に自己のアカウント等を不正に使用させる行為
          </li>
          <li>
            本サービスに関するシステム（本システムを含みます。）に関して次の①から④までに掲げる行為
            <ol className="ol--round-decimal">
              <li>本規約に定められた目的と異なる態様又は目的で使用する行為</li>
              <li>本規約に定められた条件以外で複製又は改変する行為</li>
              <li>権利の貸与、許諾（再許諾を含みます。）、売却、譲渡その他これらに類する行為</li>
              <li>知的財産権表示を削除又は改変する行為</li>
            </ol>
          </li>
          <li>
            本サービスの提供を妨害する行為、本サービスと類似又は競合するサービスを開発する行為、その他の当社の業務に影響を及ぼすと当社が判断する行為
          </li>
          <li>その他合理的な理由に基づき、当社が不適切であると判断する行為</li>
        </ol>
        <h2>パレットメーカーとの契約等</h2>
        <h3>（パレットメーカーとの契約等）</h3>
        <ol>
          <li>
            利用者は、当社が本サービスに関して提携し本システム上で表示するパレットメーカーに対して、外部事業者パレット構想図又は当社パレット構想図を利用する方法により、パレットメーカー製作図の制作業務やパレットの製造業務（以下、併せて「パレットメーカー宛委託業務」といいます。）に関する見積書の取得を依頼することができます。
          </li>
          <li>
            利用者は、前項の規定に基づき取得した見積書の内容でパレットメーカー宛委託業務の発注を希望する場合、当該見積書記載の条件に従い、当該パレットメーカーとの間で当該委託業務に関する業務委託契約（以下「パレットメーカー宛業務委託契約」といいます。）を締結することができるものとします。
          </li>
          <li>
            利用者は、前項のパレットメーカー宛業務委託契約を、利用者自身の判断と責任においてパレットメーカーとの二者間で直接締結するものとし、当社は、当該契約について何ら責任を負わないものとします。
          </li>
          <li>
            利用者は、パレットメーカーとの間でパレットメーカー宛業務委託契約を締結した場合、速やかに当社に対してその旨を報告するものとします。
          </li>
        </ol>
        <h3>（パレットメーカーと当社の連携）</h3>
        <ol>
          <li>
            当社は、前条に基づき利用者がパレットメーカーとの間でパレットメーカー宛業務委託契約を締結した場合、本サービスの提供のために合理的に必要な範囲で、当該パレットメーカーから直接利用者に関する各情報（パレットメーカー製作図を含みます。）を取得することができるものとし、利用者は予めこれに同意します。
          </li>
          <li>
            当社は、前項に基づきパレットメーカーから受領した各情報を、本契約に基づく秘密情報として取り扱うものとします。
          </li>
          <li>
            当社は、第１項に基づきパレットメーカーから受領した各情報について、パレットメーカーから書面による事前同意を得た場合に限り、利用者に対して開示するものとします。
          </li>
        </ol>
        <h2>秘密情報・個人情報及びその他データの取扱い</h2>
        <h3>（秘密情報の取扱い）</h3>
        <ol>
          <li>
            利用者及び当社は、本サービスの提供に関連して知り得た相手方の技術上又は業務上の情報であって、相手方が特に秘密である旨指定した情報並びに情報の内容及び開示の状況から合理的に秘密であると認識できる情報（複製した情報及び次条に定める個人情報を含み、以下「秘密情報」といいます。）を、善良なる管理者の注意をもって管理します。但し、次の各号のいずれかに該当する情報は、個人情報を除き、秘密情報に当たらないものとします。
            <ol className="ol--brackets">
              <li>開示した時点で、秘密情報の受領者（以下「受領者」といいます。）が既に保有していた情報</li>
              <li>開示した時点で、既に公知又は公用だった情報</li>
              <li>開示を受けた後、受領者の責めに帰すべき事由によらないで公知又は公用となった情報</li>
              <li>開示を受けた後、正当な権限を有する第三者より入手した情報</li>
              <li>受領者が開示された情報に一切アクセスせず、それと無関係に開発、創作した情報</li>
            </ol>
          </li>
          <li>
            利用者及び当社は、本規約に定める場合を除き、相手方の秘密情報を、相手方の事前の書面による同意なく、開示目的以外のいかなる目的にも使用しないものとします。
          </li>
          <li>
            利用者及び当社は、相手方の事前の書面による同意なく、相手方の秘密情報を第三者に漏洩、開示等をしてはならないものとします。但し、法令等に基づいて秘密情報の開示を要求された場合、又は裁判所、官公庁若しくは捜査機関等の公的機関から秘密情報の開示を要求された場合には、必要最小限の範囲内で秘密情報の開示等を行うことができます。なお、当該開示を行った場合、利用者及び当社は、法令上可能な範囲で、当該開示後遅滞なく相手方にその旨を通知するものとします。
          </li>
          <li>
            前項の定めにかかわらず、当社は、第35条に定める再委託を行うために必要な限度で再委託先に秘密情報を開示することがあります。この場合、当社は、再委託先の選定を適切に行い、当該第三者に対して、本規約に基づき当社が負担するものと同様の秘密保持義務を課すものとします。
          </li>
          <li>
            受領者は、相手方の要請があった場合には、相手方の指示に従い、秘密情報を相手方に返還し、又は廃棄若しくは消去します。
          </li>
          <li>本条の義務は、利用契約終了後も３年間存続するものとします。</li>
        </ol>
        <h3>（個人情報の取扱い）</h3>
        <p>
          当社は、本サービスに関連して取得した利用者の個人情報（個人情報の保護に関する法律第2条第1項で定められた情報をいい、以下「個人情報」といいます。）について、個人情報の保護に関する法律その他の法令等を遵守の上、当社が別途定めるプライバシーポリシーに従って適正に管理するものとします。
        </p>
        <h3>（本サービスにより作成されたデータの取扱い）</h3>
        <ol>
          <li>
            利用者は、本サービスにより作成されたデータ（当社パレット構想図及び当社パレット製作図のデータを含み、以下本条において同様とします。）を、利用者のパレット調達上必要な範囲で利用者の内部で閲覧し、使用することができます。
          </li>
          <li>利用者は、本サービスにより作成されたデータを、秘密情報として第22条に基づき取り扱うものとします。</li>
        </ol>
        <h3>（利用者のデータ等の取扱い）</h3>
        <ol>
          <li>
            当社は、次の各号のいずれかに該当する場合には、利用者に通知することなく、本システム又は本サービスのサーバーに保存されているコンテンツ（当社パレット構想図、外部事業者パレット構想図及び当社パレット製作図を含みます。）、当該コンテンツのデータその他利用者に関する電磁的記録（以下「利用者のデータ等」といいます。）を削除することができるものとします。
            <ol className="ol--brackets">
              <li>本サービスの利用が第19条に定める禁止行為に該当すると当社が判断した場合</li>
              <li>
                本サービスの利用が当社の業務の遂行又は設備、機器、システム（本システムを含みます。）等に著しい障害を及ぼし、又は及ぼすおそれがある場合
              </li>
              <li>法令等に従って削除する必要があると合理的に判断した場合</li>
              <li>利用契約が終了（終了原因の如何を問いません。）した場合</li>
            </ol>
          </li>
          <li>
            前項により当社が利用者のデータ等を削除し、利用者に損害が生じた場合においても、当社は一切責任を負いません。
          </li>
        </ol>
        <h2>本サービスの提供停止等</h2>
        <h3>（本サービスの提供停止）</h3>
        <ol>
          <li>
            当社は、利用者が次の各号のいずれかに該当する場合において、利用者に対して相当の期間を定めて催告をしたにもかかわらず、当該期間経過後も利用者が是正をしないときは、利用者への本サービスの提供を停止することができるものとします。但し、本サービスの提供を直ちに停止する緊急の必要があると当社が判断した場合には、事前に催告することなく、直ちに本サービスの提供を停止することができるものとします。
            <ol className="ol--brackets">
              <li>利用者の届出事項に不実、虚偽又は過誤が判明した場合</li>
              <li>支払期日を経過しても利用料金等を支払わなかった場合</li>
              <li>本規約、利用契約又は法令等に違反した場合</li>
              <li>当社からの連絡に対して、合理的な期間内に回答しなかった場合</li>
              <li>その他合理的理由に基づき、本サービスの提供を停止する必要があると当社が判断した場合</li>
            </ol>
          </li>
          <li>
            当社は、利用者が次の各号のいずれかに該当する場合には、利用者に事前に通知又は催告することなく直ちに本サービスの提供を停止することができるものとします。
            <ol className="ol--brackets">
              <li>利用者の行為が第19条に定める禁止行為に該当すると当社が判断した場合</li>
              <li>
                当社が提供するサービス（本サービスを除きます。）の利用契約を締結している場合において、当該サービスについて利用停止事由が発生したとき、又は利用者に対する当該サービスの提供を当社が停止したとき
              </li>
              <li>
                仮差押え、差押え、競売、破産手続開始、会社更生手続開始、民事再生手続開始等の申立てがあった場合、又は公租公課等の滞納による処分を受けた場合
              </li>
              <li>支払停止若しくは支払不能の状態に陥った場合、又は手形若しくは小切手が不渡りとなった場合</li>
              <li>監督官庁から行政処分を受け、又は営業を停止した場合</li>
              <li>利用者の資産、信用、支払能力に、本契約を履行し難い重大な変更が生じたことが客観的に認められる場合</li>
              <li>その他合理的理由に基づき、本サービスの提供を直ちに停止する必要があると当社が判断した場合</li>
            </ol>
          </li>
          <li>
            当社は、本サービスのメンテナンス等を実施するために、当社所定の方法により事前に利用者に対して通知することにより、本サービスの提供を停止することができるものとします。但し、本サービスの提供を直ちに停止する緊急の必要があると当社が判断した場合には、事前に通知することなく、直ちに本サービスの提供を停止することができるものとします。
          </li>
          <li>
            本条に基づき本サービスの提供が停止された場合であっても、利用契約が解約等により終了するまでの間、利用者は本規約に定められた義務を履行するものとします。また、当社は、本条に基づく本サービスの提供停止により利用者に発生した損害について、一切責任を負いません。
          </li>
        </ol>
        <h3>（本サービスの提供中止等）</h3>
        <ol>
          <li>
            当社は、次の各号のいずれかに該当する場合には、利用者に事前に通知することにより、本サービスの全部若しくは一部の提供を中止し、又は本サービス上の機能の全部若しくは一部を制限することができるものとします。但し、本サービスの提供を直ちに中止し、又は機能を制限する緊急の必要があると当社が判断した場合には、事前に通知することなく、直ちに本サービスの全部若しくは一部の提供を中止し、又は本サービス上の全部若しくは一部の機能を制限することができるものとします。
            <ol className="ol--brackets">
              <li>
                本サービスの提供に必要な設備、システム（本システムを含みます。）等に障害が生じた場合、本システムその他本サービスに関するシステムに更新作業等の必要が生じた場合、その他の保守上やむを得ない理由により、本サービスの提供中止又は機能制限の必要が生じた場合
              </li>
              <li>
                天災、台風、地震等の天変地異、戦争、暴動、内乱等の非常事態、法令等の改正、公権力の公使、通信回線等の障害その他の不可抗力事由が生じた場合
              </li>
              <li>前各号の他、当社が保守上、営業上又は技術上やむを得ないと判断した場合</li>
            </ol>
          </li>
          <li>
            当社は、本条に基づく本サービスの提供中止、又は本サービス上の機能制限により利用者に発生した損害について、一切責任を負いません。
          </li>
        </ol>
        <h3>（本サービスの変更、追加又は廃止）</h3>
        <ol>
          <li>
            当社は、当社が必要と判断した場合、本サービスの全部若しくは一部をいつでも変更、追加又は廃止（以下「変更等」といいます。）することができるものとします。
          </li>
          <li>
            当社は、本サービスに関する重要な変更等を行う場合、当社が別途定める方法により、変更等の内容について利用者に事前に通知するものとします。但し、本サービスに関する重要な変更等を直ちにする緊急の必要があると当社が判断した場合には、事前に通知することなく、直ちに変更等することができるものとし、当該変更後、速やかに変更等の内容を利用者に通知するものとします。
          </li>
          <li>当社は、本条に基づく本サービスの変更等により利用者に発生した損害について、一切責任を負いません。</li>
        </ol>
        <h2>利用契約の終了</h2>
        <h3>（当社による解約）</h3>
        <ol>
          <li>
            当社は、利用者が次の各号のいずれかに該当する場合には、利用者に事前に通知又は催告することなく、直ちに利用契約を解約することができるものとします。
            <ol className="ol--brackets">
              <li>
                第26条第1項又は第2項第1号若しくは第2号に基づき本サービスの提供を停止された利用者について、本サービスの提供停止後7営業日以内に提供停止事由が是正されない場合
              </li>
              <li>
                第26条第2項第3号から第7号のいずれかの事由に該当し、当社の業務の遂行に支障をきたすと当社が判断した場合
              </li>
              <li>
                株式移転、株式交換、会社分割、合併、事業の譲渡、株主構成の変動等、利用者の営業に著しい影響を与え得る事由が生じた場合
              </li>
            </ol>
          </li>
          <li>
            前項の規定により利用契約が解約された場合、利用者は、本サービスの利用に係る一切の債務につき当然に期限の利益を喪失し、未払債務の全額を直ちに支払うものとします。なお、利用者による本サービスの利用中に生じた利用者の一切の債務は、利用契約の解約後も、その債務が履行されるまで消滅しないものとします。
          </li>
          <li>当社は、第1項に基づく解約により利用者に発生した損害について、一切責任を負いません。</li>
        </ol>
        <h3>（利用者による解約）</h3>
        <ol>
          <li>
            利用契約の解約を希望する利用者は、第18条第1項に定める方法により、全てのユーザーの個人用アカウント削除を当社に申請することで、利用契約の解約を求めることができます。
          </li>
          <li>
            前項の申請があった場合、当社は、当該申請の日から14営業日以内に全てのユーザーの個人用アカウント及び企業用アカウントの削除手続を完了させるものとし、当該削除手続の完了日をもって利用契約の解約日とします。なお、利用者による本サービスの利用中に生じた利用者の一切の債務は、利用契約の解約後も、その債務が履行されるまで消滅しないものとします。
          </li>
        </ol>
        <h3>（利用契約終了後の措置）</h3>
        <ol>
          <li>
            利用契約が終了した場合（終了理由の如何を問いません。）、利用者は、直ちに本サービス及び本システムを利用することができなくなります。
          </li>
          <li>
            利用者は、利用契約の有効期間中及び利用契約の終了後（終了理由の如何を問いません。）、必要に応じて、自己の責任においてコンテンツ（当社パレット構想図、外部事業者パレット構想図及び当社パレット製作図を含みます。）のバックアップその他の保存処置を講ずるものとします。利用者が自己の責任おいてコンテンツの保存処置を講じず、前項の規定に基づき当社が利用者のデータ等を削除した場合、当社は一切責任を負わないものとします。
          </li>
        </ol>
        <h2>損害賠償と非保証</h2>
        <h3>（損害賠償）</h3>
        <ol>
          <li>
            利用者又は当社は、本サービスの利用に関して故意又は過失により相手方に損害を与えた場合には、相手方に対して当該損害を賠償するものとします。
          </li>
          <li>
            利用者又は当社が本サービスの利用に関して第三者に損害を与えた場合、又は第三者と紛争を生じた場合、当該損害及び紛争を発生させた当事者は、単独で自己の費用と責任においてこれを解決するものとし、相手方に一切責任を負わせないものとします。
          </li>
        </ol>
        <h3>（損害賠償責任の制限）</h3>
        <ol>
          <li>
            前条の規定その他本規約の定めにかかわらず、本サービスに関する当社の損害賠償の範囲は、本サービスの利用料金の6ヶ月分に相当する金額を限度とし、利用者に直接かつ現実に発生した損害（利用者の事業機会の損失、逸失利益その他の特別損害を除きます。）に限ります。但し、当社に故意又は重大な過失がある場合はこの限りではありません。
          </li>
          <li>
            当社が本サービスを提供すべき場合において、当社の故意又は過失により本サービスの全部を提供できないことにより利用者に損害が発生したときは、当社は、当社が本サービスの全部を提供できないことを知った日から4営業日その状態が継続したときに限り、利用者に生じた損害を賠償します。前項の規定にかかわらず、この場合の当社の損害賠償の範囲は、本サービスの利用料金を本サービスの提供不能時間で日割計算した金額に相当する金額を限度とし、利用者に直接かつ現実に発生した損害（利用者の事業機会の損失、逸失利益その他の特別損害を除きます。）に限ります。
          </li>
        </ol>
        <h3>（非保証）</h3>
        <ol>
          <li>
            当社は、本サービスを通じて提供するコンテンツ（当社パレット構想図、外部事業者パレット構想図及び当社パレット製作図を含みます。）及び本システムが、不具合又は不適合のないものであること、利用者の特定の目的に適合すること、及び利用者その他の第三者に損害を与えないことを保証しません。
          </li>
          <li>
            当社は、利用者が本サービスを通して使用したコンテンツ又は本システムにより生じた損害について、一切責任を負いません。
          </li>
          <li>
            当社は、本サービス及び本システムの利用結果に関する完全性、的確性、正確性、有用性及び適法性を保証しません。
          </li>
          <li>
            当社は、当社がガイドライン等で提示した本システムの動作環境以外の環境で本システムが動作することを保証しません。
          </li>
          <li>
            当社は、利用者の本規約に違反したことその他利用者の故意又は過失により生じた損害について、一切責任を負いません。
          </li>
          <li>
            当社は、本サービスを用いて発生した利用者と他の利用者その他の第三者（パレットメーカーを含みます。）との間の取引、紛争及びトラブル等について、一切責任を負いません。
          </li>
          <li>
            当社は、利用者のデータ等を保管する義務を負いません。利用者は、利用者に関する過去のデータ等を利用することができない場合があることを予め承諾するものとし、当社は、利用者の過去のデータ等が利用することができない場合であっても、一切責任を負わないものとします。
          </li>
        </ol>
        <h2>一般条項</h2>
        <h3>（再委託）</h3>
        <p>
          当社は、本サービスの全部又は一部を当社の責任において、第三者に再委託することがあります。この場合、当社は、委託先を適切に選定し、必要かつ適切な監督を行います。また、当社は、再委託先の行為について一切の責任を負うものとします。
        </p>
        <h3>（反社会的勢力等の排除）</h3>
        <ol>
          <li>
            当社及び利用者は、次の各号のいずれにも該当しないことを保証し、将来においても該当しないことを誓約します。
            <ol className="ol--brackets">
              <li>
                暴力団、暴力団関係企業、総会屋、社会運動等標ぼうゴロ若しくは特殊知能暴力集団等若しくはそれらの構成員等、反社会的勢力若しくはこれに準ずる者（以下、総称して「反社会的勢力等」といいます。）又は反社会的勢力等でなくなったときから5年を経過しない者であること
              </li>
              <li>反社会的勢力等に資金提供、便宜の供給等を行っていること</li>
              <li>自己又は第三者を利用して、他者に対して、暴力的行為、詐術、脅迫的言辞を用いていること</li>
            </ol>
          </li>
          <li>
            当社及び利用者は、自己又はその関係者が、直接的又は間接的に、次の各号に該当する行為を行わないことを保証し、将来においても該当しないことを誓約します。
            <ol className="ol--brackets">
              <li>
                暴力的な要求行為 法的な責任を超えた不当な要求行為 取引に関して脅迫的な言動をし、又は暴力を用いる行為
              </li>
              <li>風説を流布し、偽計若しくは威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為</li>
              <li>その他前各号に準じる行為</li>
            </ol>
          </li>
          <li>
            当社又は利用者は、相手方が前二項各号のいずれかの規定に違反した場合、相手方に事前に通知又は催告を要することなく、直ちに利用契約を解除することができます。
          </li>
          <li>当社又は利用者は、前項に基づく利用契約の解除により相手方に生じた損害について、一切責任を負いません。</li>
        </ol>
        <h3>（通知及び連絡の方法等）</h3>
        <ol>
          <li>
            当社から利用者への通知及び連絡は、電子メールの発信、本システムへの掲載、その他当社が適当と判断する方法により、利用者が当社に届け出た連絡責任者宛に行うものとします。
          </li>
          <li>
            当社が、電子メールの発信又は本システムへの掲載により利用者に対して通知又は連絡等を行う場合には、当社が当該通知又は連絡を送信又は掲載した時点でその効力が発生するものとします。
          </li>
        </ol>
        <h3>（契約上の地位等の変更）</h3>
        <p>
          利用者及び当社は、利用契約上の地位又は利用契約に基づく権利義務を、相手方の事前の書面による承諾なく第三者に移転することはできないものとします。
        </p>
        <h3>（本規約の改定）</h3>
        <ol>
          <li>
            当社は、当社の判断により、いつでも本規約を改定できるものとし、改定にあたっては、民法上の定型約款の変更に関する規定に従うものとします。
          </li>
          <li>
            本規約の変更後に本サービスを利用した場合、利用者は、変更後の規約に承諾したものとみなされ、その後は変更後の規約が利用者に適用されるものとします。
          </li>
        </ol>
        <h3>（準拠法）</h3>
        <p>本規約は、日本国法に準拠し、同法に従って解釈されるものとします。</p>
        <h3>（専属的合意管轄裁判所）</h3>
        <p>本規約に関し、訴訟の必要が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
        <h3>（協議）</h3>
        <p>
          本規約に定めのない事項又は疑義が生じた事項については、信義誠実の原則に従い当社と利用者が協議し、円満に解決を図るものとします。
        </p>
        <footer>
          <p className="align-right">以上</p>
          <p>
            附則
            <br />
            <time dateTime="2022-06-23">2022年6月23日</time>制定
          </p>
        </footer>
      </div>
    </Single>
  )
}

export default TermsPage

export const termsStyles = css`
  font-size: ${fontSize.sm};
  width: min(calc(100% - 1.25rem * 2), 62.5rem);
  margin: auto;
  h2 {
    font-size: ${fontSize.md};
    margin-top: ${space.sm};
    counter-increment: chapter;
    + * {
      margin-top: ${space.sm};
    }
    &::before {
      content: '第' counter(chapter) '章';
      padding-right: 1em;
    }
  }
  h3 {
    font-size: ${fontSize.sm};
    font-weight: 400;
    counter-increment: article;
    margin-top: ${rem(10)};
    &::before {
      content: '第' counter(article) '条';
    }
    + * {
      margin-top: ${rem(10)};
    }
  }
  p,
  li {
    line-height: 1.7;
  }
  p {
    + ol,
    + ul,
    + p {
      margin-top: ${rem(10)};
    }
  }
  li {
    + li {
      margin-top: ${space.xs};
      > ol,
      ol {
        margin-top: ${rem(8)};
      }
    }
  }
  ol {
    margin-left: 1.3em;
  }
  .ol--round-decimal {
    counter-reset: my-counter;
    list-style: none;
    margin-left: 0;
    li {
      display: flex;
      position: relative;
      padding-left: ${rem(20)};
      list-style-type: none;
      &::before {
        content: counter(my-counter);
        counter-increment: my-counter;
        position: absolute;
        top: ${rem(3)};
        left: 0;
        border: 1px solid ${colors.black.hex};
        padding-top: ${rem(1)};
        font-size: ${rem(13)};
        line-height: 1;
        color: ${colors.black.hex};
        display: flex;
        justify-content: center;
        height: ${rem(18)};
        width: ${rem(18)};
        border-radius: 50%;
        transform: scale(0.8);
      }
    }
  }
  footer {
    margin-top: clamp(${space.md}, 3vw, calc(${space.md} * 2));
    time {
      padding-right: 1em;
    }
  }

  ${mq('lg')} {
    .ol--round-decimal {
      li {
        &::before {
          top: ${rem(4)};
        }
      }
    }
  }
`
